// $(document).ready(function () {
//   $("a").each(function () {
//     if (this.href.indexOf("/collections/") != -1) {
//       if (this.href.indexOf("/products/") != -1) {
//       } else if (this.href.indexOf("v.availability") != -1) {
//       } else {
//         var oldUrl = $(this).attr("href");
//         var vl = "?filter.v.availability=1&filter.p.tag=all";
//         var newUrl = oldUrl.replace(oldUrl, oldUrl + vl);
//         $(this).attr("href", newUrl);
//       }
//     }
//   });
//   var ur = location.href;
//   var vl = "?filter.v.availability=1&filter.p.tag=all";
//   if (window.location.href.indexOf("/collections/") != -1) {
//     if (window.location.href.indexOf("p.tag=all") != -1) {
//     } else if (window.top.location.pathname.indexOf("/admin/themes/") === 0) {
//     } else {
//       location.replace(ur + vl);
//     }
//   }
// });

$(document).ready(function () {
  var backButton =
    '<img alt="Previous Arrow" src="https://cdn.shopify.com/s/files/1/2239/6447/files/back.png?v=1692747297" class="slick-prev meta-three-col-arrow">';
  var nextButton =
    '<img alt="Next Arrow" src="https://cdn.shopify.com/s/files/1/2239/6447/files/right-arrow_1.png?v=1692747517" class="slick-next meta-three-col-arrow">';

  $(".three-col-img-row-test").slick({
    dots: false,
    infinite: false,
    arrows: true,
    prevArrow: backButton,
    nextArrow: nextButton,
    cssEase: "linear",
    speed: 300,
    slidesToShow: 1.2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick",
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
          arrows: true,
          infinite: false,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
});
(function () {
  const REBUY_WIDGET_ID = 261802;
  const REBUY_SCRIPT_SRC = "https://rebuyengine.com/js/rebuy?shop=londontownusa.myshopify.com";

  function loadRebuyScript() {
    return new Promise((resolve, reject) => {
      if (window.Rebuy && typeof window.Rebuy.render === "function") {
        return resolve();
      }

      const s = document.createElement("script");
      s.src = REBUY_SCRIPT_SRC;
      s.async = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function findResultsRoot() {
    return (
      document.querySelector(".oct-quiz-wrapper--result-page") ||
      document.querySelector("#octane-quiz-outer-wrapper")
    );
  }

  function ensureMount(resultsRoot) {
    let mount = resultsRoot.querySelector("#rebuy-quiz-results-widget");
    if (!mount) {
      mount = document.createElement("div");
      mount.id = "rebuy-quiz-results-widget";
      mount.style.display = "block";
      mount.style.width = "100%";
      mount.style.margin = "32px 0";
      resultsRoot.appendChild(mount);
    }
    return mount;
  }

  async function injectWidget() {
    const resultsRoot = findResultsRoot();
    if (!resultsRoot) return;

    const mount = ensureMount(resultsRoot);

    if (mount.querySelector(`[data-rebuy-id="${REBUY_WIDGET_ID}"]`)) return;

    const widgetDiv = document.createElement("div");
    widgetDiv.setAttribute("data-rebuy-id", String(REBUY_WIDGET_ID));
    widgetDiv.style.display = "block";
    mount.appendChild(widgetDiv);

    await loadRebuyScript();

    // 🔑 THIS IS THE IMPORTANT PART
    if (window.Rebuy) {
      if (typeof window.Rebuy.render === "function") {
        window.Rebuy.render();
      } else if (typeof window.Rebuy.init === "function") {
        window.Rebuy.init();
      }
    }
  }

  document.addEventListener("octane.quiz.completed", function () {
    // wait for results DOM to be fully active
    setTimeout(injectWidget, 500);
  }, false);
})();
